const initialState = () => ({
  searchFilters: {},
  exactMatch: false,
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  resetExploreSearchFilters({ commit }) {
    commit('RESET_SEARCH_FILTERS');
  },
  setKeywords({ commit }, { keywords }) {
    commit('SET_KEYWORDS', keywords);
  },
  setExactMatch({ commit }, exactMatch) {
    commit('SET_EXACT_MATCH', exactMatch);
  },
  resetContactDirectoryKeywords({ commit }) {
    commit('RESET_KEYWORDS');
  },
};

const mutations = {
  RESET_SEARCH_FILTERS(state) {
    state.searchFilters = {
      keywords: null,
    };
  },
  SET_KEYWORDS(state, keywords) {
    state.searchFilters.keywords = keywords;
  },
  SET_EXACT_MATCH(state, exactMatch) {
    state.exactMatch = exactMatch;
  },
  RESET_KEYWORDS(state) {
    state.searchFilters.keywords = null;
  },
};

const getters = {
  searchFilters: (state) => state.searchFilters || {},
  exactMatch: (state) => state.exactMatch,
  keywords: (state) => state.searchFilters.keywords || null,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const contactDirectorySearchFilters = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
